module.exports = __webpack_public_path__ + "img/Chevron-Left_24px_2_Icon-light.e45d2dad.svg";